const AUTH_STEPS = {
  CHOOSE_AUTH: 0,
  MY_NUMBER: 1,
  CODE_VERIFICATION: 2,
  SIGN_UP: 3,
  PROFILE: 4,
  USER_DATA: 5,
}

const SIGNUP_STEPS = {
  NAME: 'name',
  EMAIL: 'email',
  INSTAGRAM: 'instagramLink',
}

const PROFILE_STEPS = {
  USERNAME: 'username',
  BIRTHDATE: 'birthdate',
  GENDER: 'gender',
  SEXUAL_ORIENTATION: 'userSexualOrientation',
  GENDER_PREFERENCES: 'preference.genders',
  LOCATION: 'location',
  OCCUPATION: 'profile.occupationPosition',
  EDUCATION: 'profile.education',
  IMAGES: 'images',
}

const FIRST_ONBOARDING_STEP = SIGNUP_STEPS.LOCATION
const MIN_NUM_OF_IMAGES = 1
// const MIN_NUM_OF_IMAGES = 3

export { AUTH_STEPS, SIGNUP_STEPS, MIN_NUM_OF_IMAGES, FIRST_ONBOARDING_STEP, PROFILE_STEPS }
